
export const commentsTableConfig = () => {
    return [

        {
            id: "name",
            header: "Пользователь",
            field: "name"
        },
        {
            id: "number",
            header: "Номер телефона",
            field: "number",
        },
        {
            id: "comment",
            header: "Комментарий",
            field: "comment",
        },
        {
            id: "date",
            header: "Дата размещения",
            field: "date",
        },
        {
            id: "actions",
            header: "",
            field: "address",
        },
    ];
}
